module.exports = __webpack_public_path__ + "487908bf10ce3127724dee01df9b5bb0.pdf";